// The one place the app reads build-time configuration. Vite inlines each
// `import.meta.import.meta.env.VITE_*` value at build time from the `.env*` files and the
// build environment. Everything else imports the named values below.
//
// Write every read as the literal `import.meta.import.meta.env.VITE_NAME`. Vite replaces
// only that exact expression; an alias such as `const {env} = import.meta`
// leaves the values unset in the production bundle.

// Vite sets MODE to 'development' for `npm run dev`, 'production' for
// `npm run build`, and 'test' under Vitest. Compare against MODE rather than
// DEV, which is also true under Vitest, so tests keep the non-development
// behavior they had under Create React App's NODE_ENV=test.
export const IS_DEVELOPMENT = import.meta.env.MODE === 'development'

export const API_URL = import.meta.env.VITE_API_URL || ''
export const API_SSE_URL = import.meta.env.VITE_API_SSE_URL || ''
export const TARGET_DEFAULT_NAMESPACE =
  import.meta.env.VITE_TARGET_DEFAULT_NAMESPACE || ''

export const FILESTACK_MP_API_KEY =
  import.meta.env.VITE_FILESTACK_MP_API_KEY || '' // microposts
export const FILESTACK_UP_API_KEY =
  import.meta.env.VITE_FILESTACK_UP_API_KEY || '' // album photos

export const BUGSNAG_API_KEY = import.meta.env.VITE_BUGSNAG_API_KEY || ''
export const BUGSNAG_STAGE = import.meta.env.VITE_BUGSNAG_STAGE || ''
// Bugsnag's --app-version in scripts/ci/build-site.sh must equal this string,
// or source maps stop lining up with error reports.
export const APP_VERSION =
  import.meta.env.VITE_VERSION && import.meta.env.VITE_BUILD_NUMBER
    ? `${import.meta.env.VITE_VERSION}.${import.meta.env.VITE_BUILD_NUMBER}`
    : '0.0.0.0'

export const GTM_PREVIEW =
  import.meta.env.VITE_GOOGLE_TAG_MANAGER_ENV_PREVIEW || ''
export const GTM_AUTH = import.meta.env.VITE_GOOGLE_TAG_MANAGER_ENV_AUTH || ''

export const CONFIGCAT_CE_FLAGS_SDK_KEY =
  import.meta.env.VITE_CONFIGCAT_CE_FLAGS_SDK_KEY || ''

export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN || ''
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID || ''

export const AIRBRIDGE_CHANNEL = import.meta.env.VITE_AIRBRIDGE_CHANNEL || ''
export const AIRBRIDGE_API_KEY = import.meta.env.VITE_AIRBRIDGE_API_KEY || ''
export const AIRBRIDGE_URL_SCHEME =
  import.meta.env.VITE_AIRBRIDGE_URL_SCHEME || ''
